module.exports = __webpack_public_path__ + "static/media/45.3dc327b9.png";